App.addModule(function(app) {

    if (app.get('app.request.path') !== 'erp/checkout/index') {
        return
    }
    
    var addressFieldMapping = {
	    'telephone': 'phone',
	    'prefix': 'title',
	    'firstname': 'given_name',
	    'lastname': 'family_name',
	    'street1': 'street_address',
	    'street2': 'street_address2',
	    'postcode': 'postal_code',
	    'city': 'city',
	    'country_id': 'country'
    };
    
    function mapAddressFields(prefix) {
	    
	    data = {
		    'email': $('#account\\:email').val()
	    };
	    
	    $.each(addressFieldMapping, function(k,v) {
		    data[v] = $('#'+prefix+'\\:'+k).val();
	    });
	    
	    return data;
    }
    
    function onLoadingError() {
        
    	document.body.querySelectorAll('.payment-method-container').forEach(el => {
            
			if (el.id.substr(15,6) === 'klarna') {
				el.remove()
			}
        })
    }
	
	function load() {
		
		document.body.querySelectorAll('.payment-method-container').forEach(el => {
            
            if (el.id.substr(15,6) === 'klarna') {
				
			    const klarna_method = el.id.substr(31)
				
				if (el.querySelector('#klarna-payments-' + klarna_method)) {
					
				    Klarna.Payments.load({
					    container: '#klarna-payments-' + klarna_method,
					    payment_method_category: klarna_method
				    })
				}
            }
        })
	}

	app.on('loaded', () => {
		
	    // _klarna: @see onestep/payment_method/klarna.phtml
	    if (!window._klarna) {
		    onLoadingError()
		    return
	    }
	    
		app.loadScript('https://x.klarnacdn.net/kp/lib/v1/api.js', () => {
		    
		    try {
				
			    Klarna.Payments.init({client_token: _klarna.token})
			    
				load()
		    }
		    catch (e) {
			    app.logException(e)
			    onLoadingError()
		    }
	    })
	})

	app.on('checkout:completeSection', function(section) {
	    if (section === 'address' || section === 'shipping_method') {
			load()
		}
    })

    app.on('checkout:placeOrder', function(checkout) {
	    
		var method = checkout.data.get('payment[method]')
		
	    if (!method || method.substr(0, 6) !== 'klarna') {
		    return;
	    }
	    
	    method = method.substr(16);
	    
	    checkout.hold = true;

	    if (!$('input[name="billing[id]"]').length) {
		    
		    _klarna.data['billing_address'] = mapAddressFields('billing');
		    
		    if ($('#use-shipping-address:checked').length) {
			    _klarna.data['shipping_address'] = mapAddressFields('shipping');
		    }
		    else {
			    _klarna.data['shipping_address'] = _klarna.data['billing_address'];
		    }
	    }
	    
	    Klarna.Payments.authorize(
		    {payment_method_category: method},
		    _klarna.data,
		    function(response) {
    			
    			if (response.approved) {
    				
    				app.dispatchEvent('klarna:authApproved', method);
    				
    				$('.kp_payment_auth_token_field').val(response.authorization_token);
    				
    				app.dispatchEvent('checkout:placeOrderStart');
					
					checkout.placeOrder()
    			}
    			else {
    			    
    				app.dispatchEvent('klarna:authFailed', method);
    				
    				$('.kp_payment_auth_token_field').val('');
    			}
    		}
	    );
    });
})
